import ComponentManager from '@/Management/ComponentManager';
import ControlFactory from '@/Factories/ControlFactory';
import ExtIEGAssociationGridViewModel from '@/Components/ExtendedInlineEditingGrid/Associations/ExtIEGAssociationGridViewModel';
import ExtIEGAssociationGrid from '@/Components/ExtendedInlineEditingGrid/Associations/ExtIEGAssociationGrid';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';

/* 
 * Dies stellt ein Grid in einer Zelle im IEG dar.
 */
export default class ExtIEGAssociationGridFactory extends ControlFactory {

    public controlDomElement: JQuery;

    public context: DetailViewContext;

    public detailViewContext: DetailViewContext;

    /**
     * @override
     */
    public viewModel: ExtIEGAssociationGridViewModel;

    constructor(private params: any) {
        super(params);
        this.detailViewContext = this.paramOrDefault(params.detailViewContext);
        this.undisposeProperties.push('detailViewContext');
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.controlDomElement != null) {
            return this.controlDomElement;
        }

        this.viewModel = this.createViewModel(this.createViewModelParameter());
        this.viewModel.refresh();

        this.control = this.createControl(this.viewModel);

        let tuple = this.control.getTuple();
        this.controlDomElement = tuple.control;

        return this.controlDomElement;
    }

    protected createViewModelParameter(): any {
        return {
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            detailViewItem: this.detailViewItem,
            detailViewContext: this.detailViewContext,
            editContext: this.context,
            isEnabled: this.isEnabled
        };
    }

    protected createViewModel(parameter: any): ExtIEGAssociationGridViewModel {
        const ViewModel = ComponentManager.getViewModel<typeof ExtIEGAssociationGridViewModel>('ExtIEGAssociationGrid');
        return new ViewModel(parameter);
    }

    protected createControl(viewModel: ExtIEGAssociationGridViewModel): ExtIEGAssociationGrid {
        const Control = ComponentManager.getControl<typeof ExtIEGAssociationGrid>('ExtIEGAssociationGrid');
        return new Control(this.viewModel, $('<div>'));
    }
}

ComponentManager.setFactory('ExtIEGAssociationGrid', ExtIEGAssociationGridFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');